import { AnchorHTMLAttributes, ReactElement } from 'react'
import { elementGuidOfHref } from '../elementLinks'
import ElementLink from './ElementLink'

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  // Streamdown passes the hast node to every element renderer.
  node?: unknown
}

/**
 * Links in chat answers: element links (`#element:<guid>`) highlight the
 * element in the scene; every other link opens in a new tab, as Streamdown's
 * own link renderer (which this replaces) does.
 */
const ChatLink = ({ href, children, node: _node, ...props }: Props): ReactElement => {
  const guid = elementGuidOfHref(href)
  if (guid) return <ElementLink guid={guid}>{children}</ElementLink>

  return (
    <a {...props} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}

export default ChatLink
